import React from 'react';
import PropTypes from 'prop-types';
import { PopupBack } from '../../_atoms/PopupBack';
import { PopupFrame } from '../../_atoms/PopupFrame';
import { ImageButton } from '../ImageButton';
import { closePop } from '../../../store/CommonSlice';
import { useDispatch } from 'react-redux';
import { resetTrack } from '../../../store/TrackSlice';
import { resetVideo } from '../../../store/VideoSlice';
import { resetCard } from '../../../store/CardSlice';
import { closeMenu } from '../../../store/MenuSlice';
import { resetGame } from '../../../store/GameSlice';

export const PopupCommon = (props) => {
  const dispatch = useDispatch();
  
  return (
    <PopupBack>
      <PopupFrame type={props.type}>{props.children}</PopupFrame>
      <ImageButton 
        type="close"
        value={props.type}
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/common/popUp_close.png"
        alt="close"
        onClick={() => (
          dispatch(closePop()),
          dispatch(resetTrack()),
          dispatch(resetVideo()),
          dispatch(resetCard()),
          dispatch(resetGame()),
          dispatch(closeMenu())
        )}
      />
    </PopupBack>
  );
};

PopupCommon.propTypes = {
  type : PropTypes.string
};

PopupCommon.defaultProps = {
  type : 'audio'
};